import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2151fcb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-flex tw-justify-center tw-bg-[#E4F1FF]" }
const _hoisted_2 = {
  id: "click-box",
  class: "tw-relative tw-w-[36vw] tw-h-full tw-flex-col tw-flex tw-justify-center tw-items-center"
}
const _hoisted_3 = { class: "tw-flex tw-items-center tw-flex-col tw-gap-[20px] tw-px-[112px]" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[25px] tw-not-italic tw-font-semibold tw-leading-[100%]" }
const _hoisted_5 = { class: "tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[150%] tw-text-center" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-[5px] tw-bg-[#FFFFFF] tw-rounded-md tw-mt-[40px] tw-p-[25px]" }
const _hoisted_7 = { class: "tw-text-[#211F58] tw-text-[20px] tw-not-italic tw-font-semibold tw-leading-[130%]" }
const _hoisted_8 = { class: "tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[130%]" }

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import CyberSystemIcon from "@/components/svgs/cyberSystemIcon.vue";
import router from "@/router";
import { getComponentUiText } from "@/utils/utilities";
import { routers } from "@/utils/constants";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'pentests',
  setup(__props) {

const onNavigateToDashboard = () => {
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-home-1"), //"Home",
    getComponentUiText("app-menu-submenu-home-dashboard-1"), //"Dashboard",
  ]);
  store.dispatch("Navigation/setPrimaryMenuIndex", 0);
  router.replace(routers.dashboard);
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern4, {
          page: "LANDING",
          class: "tw-bg-[#E4F1FF] !tw-top-0"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(CyberSystemIcon, { class: "tw-mb-[10px]" }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("user-temp-holding-heading-1")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-landing-heading-sub-1")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)("app-landing-pentests-title-1")), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getComponentUiText)("app-landing-pentests-info-1")), 1)
          ]),
          _createVNode(_component_b_button, {
            variant: "primary",
            class: "button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
            onClick: onNavigateToDashboard
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-landing-button-return-1")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})